export enum ExistingMatch {
    Skip = 1,
    Update = 2
}